export default {
  name: "helpers",
  data() {
    return {
    }
  },
  watch: {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    clone(item) {
      return JSON.parse(JSON.stringify(item))
    },
    getRes(it) {
      return it.resources.find(res => res.languageId == this.tabs.languageIdActive)
    },
    getResWithLangId(it, languageId) {
      return it.resources.find(res => res.languageId == languageId)
    },
    addItemAtEnd(template, list) {
      var item = this.clone(template)
      list.push(item)
      this.$isModified = true
    },
    addItemAtStart(template, list) {
      var item = this.clone(template)
      list.unshift(item)
      this.$isModified = true
    },
    removeItemAtIndex(list, indx) {
      list.splice(indx, 1)
      this.$isModified = true
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
    },
    addKeysToList(list) {
      if (!window._.isArrayLike(list)) { return [] }
      list.filter(it => { return !it.listKey || it.listKey === '' }).forEach(it => {
        it.listKey = this.uuidv4()
      })
      return list
    },
    addListKeyToItem(item) {
      if (!window._.isObjectLike(item)) { return { listKey: this.uuidv4() } }
      if (!item.listKey || item.listKey === '') {
        item.listKey = this.uuidv4()
      }

      return item
    },
    getOddEvenForRow(indx) {
      return indx % 2 === 0 ? "even" : "odd"
    },
    formatDate: function (value) {
      if (value == null) return "";
      return moment(value).local().format("YYYY-MM-DD HH:mm");
    },
    formatDateFromNow: function (value) {
      if (value == null) return "";
      return moment(value).local().fromNow();
    },
    formatBoolean: function (value) {
      return value == null || !value ? this.$t("no") : this.$t("yes");
    },
    formatActive: function (value) {
      return value == null || !value
        ? '<span class="isDisabled">' + this.$t("no") + "</span>"
        : '<span class="isActive">' + this.$t("yes") + "</span>";
    },
  }
}



//////////////////
// WEBPACK FOOTER
// ./mixins/helpers.js
// module id = W6mN
// module chunks = 18